import React from 'react';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import AboutUs from '../components/AboutUs';
import Services from '../components/Services';
import Offer from '../components/We_offer';
import { Helmet } from "react-helmet";


const Home = () => {
    return (
        <>
            <Helmet>
                <title>Huzurlu Taşin | Istanbul Evden Eve Nakliye </title>
                <meta
                    name="description"
                    content="Huzurlu Taşin evden eve nakliye hizmetlerinde güvenilir, hızlı ve profesyonel taşıma çözümleri. Pendik ve İstanbul genelinde Huzurlu Taşin."
                />
                <meta name="keywords" content="Huzurlu Taşin evden eve nakliye, ev taşıma, nakliyat, pendik nakliyat, huzurlu Taşin" />
            </Helmet>
            <Hero />
            <AboutUs />
            <Offer />
            <Services />
            <Footer />
        </>

    )
}

export default Home;

